export const rekamMedis =
{
  path: '/rm',
  name: 'rm',
  hidden: false,
  component: () => import('@/components/rm/index'),
  meta: {
    title: 'Rekam Medis',
    icon: 'fa-book-medical',
    roles: ['dokter'],
    member_type: "dokter"
  },
}
export default rekamMedis



// WEBPACK FOOTER //
// ./src/router/modules/rekam-medis.js